import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "../lib/api";

// Pulsante donazione flottante (colletta PayPal): stesso stile dello ShareFab
// (chamfer arancione + glow), basso a sinistra, visibile su TUTTE le pagine.
// Il link della colletta arriva dalle impostazioni del sito (Staff -> PayPal).
export function DonateFab() {
  const [url, setUrl] = useState("");
  useEffect(() => {
    api.get("/settings").then(({ data }) => setUrl(data.paypal_url || "")).catch(() => {});
  }, []);
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="donate-fab"
      aria-label="Supporta il progetto con PayPal"
      className="fixed bottom-5 left-5 z-50 chamfer-sm bg-wardogs hover:bg-wardogs-hover text-[#050505] font-mono text-[11px] uppercase tracking-[0.2em] font-bold px-5 py-3 flex items-center gap-2 transition-all duration-300"
      style={{ boxShadow: "0 0 24px rgba(255,92,0,0.35)" }}
    >
      <Heart className="w-4 h-4" /> Supporta il progetto
    </a>
  );
}
